"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcCard = exports.AcCardDefaultHeight = exports.AcCardDefaultWidth = void 0;
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importDefault(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var FaIcon_1 = require("../util/FaIcon");
var AcCard_module_scss_1 = __importDefault(require("./AcCard.module.scss"));
exports.AcCardDefaultWidth = 160;
exports.AcCardDefaultHeight = 80;
var AcCard = function (_a) {
    var _b, _c;
    var _d = _a.width, width = _d === void 0 ? exports.AcCardDefaultWidth : _d, _e = _a.height, height = _e === void 0 ? exports.AcCardDefaultHeight : _e, _f = _a.block, block = _f === void 0 ? false : _f, _g = _a.active, active = _g === void 0 ? false : _g, name = _a.name, onClick = _a.onClick, draggable = _a.draggable, _h = _a.className, className = _h === void 0 ? '' : _h, _j = _a.overflow, overflow = _j === void 0 ? 'hidden' : _j, _k = _a.textAlign, textAlign = _k === void 0 ? 'center' : _k, children = _a.children;
    var onClickCard = function () {
        if (onClick)
            onClick(name);
    };
    return (react_1.default.createElement(react_bootstrap_1.Card, { onClick: onClickCard, className: clsx_1.default(className, (_b = {}, _b[AcCard_module_scss_1.default.card] = !active, _b), (_c = {}, _c[AcCard_module_scss_1.default.cardActive] = active, _c), { 'w-100': block }), text: "primary", style: {
            width: width,
            minWidth: block ? undefined : width,
            maxWidth: block ? undefined : width,
            height: height,
            minHeight: height,
            maxHeight: height,
            overflow: overflow,
            cursor: onClick ? 'pointer' : draggable ? 'grabbing' : 'auto',
        } },
        react_1.default.createElement(react_bootstrap_1.Card.Body, { className: "text-" + textAlign + " fs-default font-weight-bold d-flex flex-column justify-content-center" },
            children,
            draggable && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "position-absolute", style: {
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 'auto',
                        margin: 'auto',
                        width: '14px',
                        pointerEvents: 'none',
                    } },
                    react_1.default.createElement(FaIcon_1.FaIcon, { icon: "fas fa-grip-horizontal", size: "default", variant: "secondary" })),
                react_1.default.createElement("div", { className: "position-absolute", style: {
                        top: 'auto',
                        left: 0,
                        right: 0,
                        bottom: 0,
                        margin: 'auto',
                        width: '14px',
                        pointerEvents: 'none',
                    } },
                    react_1.default.createElement(FaIcon_1.FaIcon, { icon: "fas fa-grip-horizontal", size: "default", variant: "secondary" })))))));
};
exports.AcCard = AcCard;
exports.AcCard.displayName = 'AcCard';
//# sourceMappingURL=AcCard.js.map